import { ComponentPropsWithoutRef, ReactNode } from 'react';
import classNames from 'classnames';

export const baseInputClasses = '';

export interface InputWrapperProps {
  simple?: boolean;
  icon?: ReactNode;
  suffix?: ReactNode;
  label?: string;
  error?: string;
  description?: ReactNode;
}

export const InputWrapper = ({ className, children, simple, icon, suffix, label, error, description, ...props }: ComponentPropsWithoutRef<'label'> & InputWrapperProps) => {
  return (
    <label
      className={classNames(
        'flex flex-col gap-1 text-body-2-xl font-medium text-secondary-500 grow',
        'hover:text-secondary-600',
        'has-[:focus]:text-secondary-600',
        'has-[:invalid]:text-red-600',
        'has-[:disabled]:text-secondary-300',
        className,
      )}
      {...props}
    >
      {!simple && <span className="text-caption-xl">{label}</span>}
      <div
        className={classNames(
          'flex gap-2 border rounded-lg border-secondary-400 bg-white items-center box-content *:my-2.5 [&>:first-child]:ml-3 [&>:last-child]:mr-3',
          'hover:border-secondary-600',
          'has-[:focus]:border-primary-300',
          'has-[:invalid]:border-red-500',
          'has-[:disabled]:border-secondary-200 has-[:disabled]:text-secondary-300',
          '[&_input]:bg-transparent [&_input]:flex-1 [&_input]:w-full [&_input]:text-body-2-xl [&_input]:font-medium',
          '[&_input:focus]:outline-0 [&_input:placeholder]:font-normal [&_input:placeholder]:text-secondary-400',
          '[&_input:invalid]:text-secondary-600',
        )}
      >
        {!simple && icon && (<div className="size-5">{icon}</div>)}
        {children}
        {!simple && suffix && (<div className="size-5">{suffix}</div>)}
      </div>
      {!simple && <div className="text-captionSmall-xl">{error || description}</div>}
    </label>
  )
}
